import { createQueryKeys } from '@lukemorales/query-key-factory';
import { IProdoqCompanyResponse, IProdoqMenuResponse, IProdoqRoleResponse } from '../../types/prodoq';
import { prodoqApis } from '../../apis/prodoq/apis';
import type { IGetProdoqCompaniesParams, IProdoqCompanyIdParams } from '../../apis/prodoq/types';

export const prodoqQueries = createQueryKeys('prodoq', {
  companies: (params: IGetProdoqCompaniesParams) => ({
    queryKey: [params.pg, params.pgSize, params.searchType, params.searchWord],
    queryFn: async (): Promise<{ data: { totalCount: number; list: IProdoqCompanyResponse[] } }> => {
      const response = await prodoqApis.getProdoqCompanies(params);
      return response.data;
    },
  }),
  roles: (params: IProdoqCompanyIdParams) => ({
    queryKey: [params.companyId],
    queryFn: async (): Promise<{ data: IProdoqRoleResponse[] }> => {
      const response = await prodoqApis.getProdocqRolesByCompany(params);
      return response.data;
    },
  }),
  menuList: () => ({
    queryKey: ['menuList'],
    queryFn: async (): Promise<{ data: IProdoqMenuResponse[] }> => {
      const response = await prodoqApis.getProdoqMenuList();
      return response.data;
    },
  }),
  permissions: (params: IProdoqCompanyIdParams) => ({
    queryKey: [params.companyId],
    queryFn: async (): Promise<{ data: { menus: IProdoqMenuResponse[]; roles: IProdoqRoleResponse[] } }> => {
      const response = await prodoqApis.getProdocqPermissionsByCompany(params);
      return response.data;
    },
  }),
});
